import FinancialDetails from './financial-details';

export default FinancialDetails;
